import { MY_WALLET } from "@stadium/constants/wallets";

export const USE_WALLET_OPTIONS = {
  useWalletMoney: {
    key: "useWalletMoney",
    label: MY_WALLET,
  },
  useGlobalPoint: {
    key: "useGlobalPoint",
    label: "Stadium Points",
  },
  // Currently used only for resetting
  useTeamPoint: {
    key: "useTeamPoint",
    label: "Team Walet",
  },
  useStoreSpecificPoint: {
    key: "useStoreSpecificPoint",
    label: "Shop Points",
  },
};
